<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="true"
      offset-y
      bottom
      origin="center center"
      transition="slide--transition"
      style="margin-right: -10px"
      max-height="400"
    >
      <v-btn large color="primary" class="px-2" slot="activator">
        <v-icon left>flaticon-chef</v-icon>
        {{ selected.name }}
        <v-icon right>expand_more</v-icon>
      </v-btn>

      <v-card>
        <v-layout row wrap>
          <v-flex>
            <v-list class="py-0">
              <div
                v-for="(item, i) in lines"
                :key="`line-${item.id}-${item.kitchen_line_id}`"
              >
                <v-list-tile
                  @click="changeLine(item)"
                  :disabled="item.id == selected.id"
                >
                  <v-list-tile-content>
                    <div>
                      <span v-if="item.default">
                        <v-icon small>flaticon-chef</v-icon>&nbsp;
                      </span>
                      {{ item.name }}
                    </div>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-icon v-if="item.id == selected.id" color="success"
                      >check</v-icon
                    >
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider v-if="lines.length != i + 1"></v-divider>
              </div>
            </v-list>
          </v-flex>
        </v-layout>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "kitchen-line",
  data() {
    return {
      menu: false,
      selected: {},
      lines: [],
      storeId: 0,
    };
  },
  methods: {
    get() {
      let url = this.$apiURL + "store/" + this.storeId + "/kitchenLines";
      this.$http.get(url).then(function (resp) {
        this.lines = resp.body.lines || [];
        this.lines.unshift(this.chefMode());
      });
    },
    chefMode() {
      return {
        id: 0,
        kitchen_line_id: 0,
        kitchen_line_name: "Chef",
        name: "Chef",
        default: true,
      };
    },
    changeLine(line) {
      this.selected = {
        id: line.id,
        kitchen_line_id: line.kitchen_line_id,
        kitchen_line_name: line.kitchen_line_name,
        name: line.name,
      };
      this.$store.dispatch("setKitchenLine", {
        kl: this.selected
      });
    },
    init() {
      let line = localStorage.getItem("kitchenLine");
      if (line) {
        this.selected = JSON.parse(line);
        return;
      }
    },
  },
  created() {
    this.storeId = localStorage.getItem("storeId");
    this.get();
    this.init();
  },
};
</script>
